var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoBbPacht(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1100,
    height: 180,
    viewBox: "0 50 1100 180",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333333,0,0,-1.3333333,0,300.42133)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(653.1074,118.0312)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 0.586,0 1.141,0.128 1.649,0.378 2.176,0.641 2.62,0.984 3.006,1.425 3.391,1.869 3.696,2.386 3.911,2.962 4.13,3.536 4.24,4.146 4.24,4.776 4.24,5.373 4.13,5.967 3.912,6.541 3.695,7.12 3.392,7.638 3.013,8.08 2.638,8.519 2.184,8.881 1.659,9.156 1.148,9.422 0.604,9.552 0,9.552 H -5.833 V 0 Z m -12.143,-20.919 c -1.046,0 -1.668,0.643 -1.668,1.722 v 34.531 c 0,1.14 0.633,1.821 1.694,1.821 H 0.978 c 1.648,0 3.19,-0.353 4.583,-1.048 1.381,-0.688 2.585,-1.62 3.579,-2.77 0.995,-1.141 1.776,-2.471 2.321,-3.951 0.549,-1.476 0.827,-3.04 0.827,-4.647 0,-1.572 -0.273,-3.11 -0.814,-4.571 C 10.937,-1.287 10.167,-2.605 9.186,-3.747 8.204,-4.887 7.013,-5.815 5.647,-6.504 4.27,-7.199 2.741,-7.551 1.103,-7.551 h -6.936 v -11.646 c 0,-1.079 -0.631,-1.722 -1.691,-1.722 z M 34.196,-6.41 30.239,5.086 C 29.622,3.362 29.01,1.591 28.398,-0.224 27.68,-2.356 26.96,-4.417 26.236,-6.41 Z m 5.499,-14.509 c -0.491,0 -0.894,0.124 -1.197,0.37 -0.272,0.219 -0.495,0.542 -0.658,0.963 l -1.297,3.529 c -0.24,0.65 -0.474,1.307 -0.704,1.969 H 22.551 c -0.348,-0.995 -0.686,-1.937 -1.016,-2.824 -0.375,-1.011 -0.692,-1.893 -0.95,-2.647 -0.312,-0.88 -0.957,-1.36 -1.821,-1.36 h -4.612 c -0.42,0 -0.778,0.093 -1.064,0.279 -0.364,0.241 -0.562,0.62 -0.562,1.072 0,0.17 0.017,0.303 0.052,0.418 0.072,0.311 0.167,0.636 0.273,0.94 l 0.263,0.759 12.432,33.238 c 0.055,0.226 0.229,0.517 0.515,0.823 0.334,0.357 0.792,0.545 1.324,0.545 h 3.712 c 0.718,0 1.106,-0.294 1.306,-0.541 0.192,-0.236 0.334,-0.443 0.432,-0.632 l 0.789,-1.993 12.217,-32.82 v -0.118 c 0.003,-0.021 0.012,-0.072 0.024,-0.14 0.032,-0.173 0.044,-0.316 0.044,-0.429 0,-0.33 -0.12,-1.401 -1.67,-1.401 z m 68.313,0 c -1.046,0 -1.668,0.653 -1.668,1.747 V -4.855 H 92.186 v -14.317 c 0,-1.094 -0.667,-1.747 -1.783,-1.747 h -4.55 c -1.031,0 -1.644,0.625 -1.644,1.673 v 34.654 c 0,0.433 0.136,0.824 0.405,1.163 0.302,0.382 0.731,0.584 1.239,0.584 h 4.597 c 0.429,0 0.826,-0.168 1.181,-0.498 0.364,-0.34 0.555,-0.772 0.555,-1.249 V 3.244 h 14.154 v 12.164 c 0,0.456 0.145,0.858 0.434,1.195 0.308,0.361 0.734,0.552 1.234,0.552 h 4.527 c 0.467,0 0.877,-0.149 1.22,-0.443 0.368,-0.316 0.563,-0.759 0.563,-1.279 v -34.605 c 0,-1.094 -0.649,-1.747 -1.737,-1.747 z m 23.255,0 c -0.446,0 -0.862,0.175 -1.206,0.506 -0.351,0.338 -0.535,0.786 -0.535,1.29 V 9.181 h -8.127 c -0.486,0 -0.914,0.177 -1.236,0.512 -0.318,0.328 -0.48,0.795 -0.48,1.384 v 4.331 c 0,0.503 0.169,0.938 0.491,1.258 0.322,0.321 0.745,0.489 1.225,0.489 h 24.253 c 0.431,0 0.824,-0.142 1.165,-0.421 0.249,-0.203 0.561,-0.588 0.621,-1.269 l 0.002,-4.388 c 0,-0.478 -0.144,-0.905 -0.426,-1.27 -0.221,-0.286 -0.638,-0.626 -1.362,-0.626 h -8.104 v -28.304 c 0,-0.456 -0.148,-0.864 -0.439,-1.213 -0.316,-0.381 -0.767,-0.583 -1.3,-0.583 z m -65.27,-0.544 c -1.688,0 -3.331,0.232 -4.88,0.695 -1.554,0.462 -3.025,1.129 -4.371,1.981 -1.345,0.846 -2.587,1.878 -3.693,3.066 -1.096,1.175 -2.055,2.502 -2.849,3.942 -0.791,1.436 -1.409,3.003 -1.837,4.659 -0.426,1.657 -0.642,3.407 -0.642,5.201 0,1.792 0.216,3.542 0.642,5.201 0.428,1.652 1.044,3.226 1.836,4.68 0.792,1.454 1.75,2.794 2.848,3.982 1.108,1.195 2.352,2.228 3.698,3.068 1.346,0.843 2.815,1.509 4.365,1.978 1.554,0.471 3.196,0.71 4.883,0.71 1.888,0 3.711,-0.291 5.418,-0.864 1.697,-0.57 3.316,-1.403 4.809,-2.479 0.216,-0.133 0.432,-0.33 0.606,-0.56 0.208,-0.284 0.312,-0.616 0.312,-0.989 0,-0.277 -0.066,-0.562 -0.198,-0.846 L 74.686,7.839 C 74.26,7.215 73.797,6.928 73.278,6.928 73.11,6.928 72.928,6.96 72.741,7.025 72.567,7.085 72.397,7.17 72.224,7.283 71.275,8.01 70.286,8.56 69.244,8.95 68.215,9.333 67.105,9.527 65.946,9.527 64.488,9.527 63.134,9.229 61.922,8.64 60.702,8.046 59.633,7.229 58.743,6.212 57.846,5.189 57.139,3.97 56.641,2.585 56.139,1.195 55.884,-0.32 55.884,-1.919 c 0,-1.584 0.255,-3.087 0.755,-4.465 0.5,-1.377 1.207,-2.593 2.104,-3.616 0.89,-1.02 1.958,-1.832 3.176,-2.415 1.212,-0.582 2.566,-0.878 4.027,-0.878 1.16,0 2.283,0.195 3.336,0.58 1.061,0.387 2.052,0.937 2.945,1.634 0.191,0.152 0.402,0.261 0.624,0.317 0.152,0.038 0.275,0.065 0.381,0.085 h 0.032 c 0.577,0 1.017,-0.272 1.413,-0.798 l 2.334,-4.21 c 0.155,-0.326 0.221,-0.603 0.221,-0.863 0,-0.388 -0.124,-0.736 -0.36,-1.003 -0.155,-0.178 -0.335,-0.348 -0.536,-0.506 -1.513,-1.088 -3.142,-1.93 -4.863,-2.518 -1.725,-0.589 -3.57,-0.888 -5.48,-0.888",
    style: {
      fill: "#233833",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(165.2441,73.1633)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 25.15,0 45.538,20.388 45.538,45.538 45.538,70.688 25.15,91.076 0,91.076 -25.15,91.076 -45.538,70.688 -45.538,45.538 -45.538,20.388 -25.15,0 0,0",
    style: {
      fill: "#fcc243",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(165.2441,149.999)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -17.61,0 -31.925,-14.042 -31.925,-31.292 0,-0.84 0.039,-1.68 0.116,-2.508 1.294,-16.097 15.064,-28.796 31.809,-28.796 17.598,0 31.925,14.044 31.925,31.304 C 31.925,-14.042 17.598,0 0,0 m 16.642,-7.59 c 7.679,-5.185 12.722,-13.875 12.722,-23.702 H 16.642 Z M 2.262,-2.6 c 4.255,-0.297 8.263,-1.511 11.819,-3.425 V -31.292 H 2.262 Z m -2.559,0.092 v -27.49 l -19.939,19.55 c 5.197,4.862 12.219,7.875 19.939,7.94 m -27.567,-19.667 9.296,-9.117 h -10.81 c 0,3.182 0.531,6.247 1.514,9.117 m 10.317,-32.197 c -6.53,4.785 -10.977,12.168 -11.715,20.572 h 11.715 z M 0,-60.086 c -5.482,0 -10.602,1.473 -15,4.046 v 21.245 L 9.296,-58.599 C 6.375,-59.569 3.245,-60.086 0,-60.086 m 11.896,2.469 -38.752,37.989 c 1.229,2.702 2.871,5.198 4.848,7.384 l 21.711,-21.298 0.271,-0.258 19.447,-19.071 c -2.224,-1.928 -4.758,-3.543 -7.525,-4.746 m 9.349,6.478 L 3.568,-33.8 h 25.68 c -0.582,-6.697 -3.53,-12.748 -8.003,-17.339",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(165.2441,149.999)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -17.61,0 -31.925,-14.042 -31.925,-31.292 0,-0.84 0.039,-1.68 0.116,-2.508 1.294,-16.097 15.064,-28.796 31.809,-28.796 17.598,0 31.925,14.044 31.925,31.304 C 31.925,-14.042 17.598,0 0,0 Z m 16.642,-7.59 c 7.679,-5.185 12.722,-13.875 12.722,-23.702 H 16.642 Z M 2.262,-2.6 c 4.255,-0.297 8.263,-1.511 11.819,-3.425 V -31.292 H 2.262 Z m -2.559,0.092 v -27.49 l -19.939,19.55 c 5.197,4.862 12.219,7.875 19.939,7.94 z m -27.567,-19.667 9.296,-9.117 h -10.81 c 0,3.182 0.531,6.247 1.514,9.117 z m 10.317,-32.197 c -6.53,4.785 -10.977,12.168 -11.715,20.572 h 11.715 z M 0,-60.086 c -5.482,0 -10.602,1.473 -15,4.046 v 21.245 L 9.296,-58.599 C 6.375,-59.569 3.245,-60.086 0,-60.086 Z m 11.896,2.469 -38.752,37.989 c 1.229,2.702 2.871,5.198 4.848,7.384 l 21.711,-21.298 0.271,-0.258 19.447,-19.071 c -2.224,-1.928 -4.758,-3.543 -7.525,-4.746 z m 9.349,6.478 L 3.568,-33.8 h 25.68 c -0.582,-6.697 -3.53,-12.748 -8.003,-17.339 z",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 0.763,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(79.3354,71.7823)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 25.871,0 46.919,21.048 46.919,46.919 46.919,72.79 25.871,93.838 0,93.838 -25.871,93.838 -46.919,72.79 -46.919,46.919 -46.919,21.048 -25.871,0 0,0",
    style: {
      fill: "#0fb2aa",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(79.3354,71.7823)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 25.871,0 46.919,21.048 46.919,46.919 46.919,72.79 25.871,93.838 0,93.838 -25.871,93.838 -46.919,72.79 -46.919,46.919 -46.919,21.048 -25.871,0 0,0 Z",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 2.5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(257.4162,116.2746)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 5.197,-2.426 5.197,-7.972 5.197,-7.972 0,-11.091 -11.434,-11.438 -13.859,-11.438 h -12.126 c -0.694,0 -1.04,0.347 -1.04,1.04 v 36.74 c 0,0.347 0.346,1.04 1.04,1.04 h 12.126 c 0,0 13.513,0.346 13.513,-11.438 C 4.504,3.813 2.771,1.386 0,0 m -13.859,3.813 h 5.197 c 0,0 4.851,0 4.851,3.466 0,3.812 -4.851,3.812 -4.851,3.812 h -5.197 z M -3.464,-7.625 c 0,3.812 -5.545,3.466 -5.545,3.466 h -5.197 v -7.279 h 5.197 c 2.427,0 5.545,0.693 5.545,3.813",
    style: {
      fill: "#233833",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(304.883,115.928)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,-9.705 -6.236,-19.755 -19.055,-19.755 -12.82,0 -19.057,10.05 -19.057,19.755 0,9.705 6.237,19.756 19.057,19.756 C -6.236,19.756 0,10.051 0,0 m -8.315,0 c 0,5.892 -3.465,11.785 -10.394,11.785 -6.93,0 -10.395,-5.893 -10.395,-11.785 0,-5.892 3.465,-11.785 10.395,-11.785 6.929,0 10.394,5.893 10.394,11.785",
    style: {
      fill: "#233833",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(319.4265,127.5045)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v -7.492 h 13.617 c 0.68,0 1.021,-0.341 1.021,-1.021 v -5.789 c 0,-0.342 -0.341,-1.023 -1.021,-1.023 H 0 v -7.49 h 16.68 c 0.681,0 1.362,-0.342 1.362,-1.023 v -5.789 c 0,-0.34 -0.34,-1.021 -1.362,-1.021 H -6.808 c -0.681,0 -1.022,0.34 -1.022,1.021 V 6.811 c 0,0.341 0.341,1.022 1.022,1.022 H 16.68 c 0.681,0 1.362,-0.341 1.362,-1.022 V 1.021 C 18.042,0.681 17.702,0 16.68,0 Z",
    style: {
      fill: "#233833",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(355.8146,112.1154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -2.771 v -14.211 c 0,-0.346 -0.347,-1.04 -1.387,-1.04 h -5.89 c -0.692,0 -1.039,0.347 -1.039,1.04 v 36.392 c 0,0.347 0.347,1.04 1.039,1.04 H 2.08 c 2.424,0 13.164,0 13.164,-11.436 0,-5.893 -3.118,-8.666 -6.582,-10.399 1.04,-2.426 2.425,-5.199 3.464,-7.625 l 3.465,-7.279 c 0.347,-0.693 0,-1.386 -1.04,-1.386 H 7.969 c -0.347,0 -1.04,0.347 -1.04,0.693 z M -2.771,7.279 H 2.08 c 1.384,0 4.849,0.346 4.849,3.812 0,3.466 -3.811,3.813 -4.849,3.813 h -4.851 z",
    style: {
      fill: "#233833",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(437.5823,116.2746)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 5.197,-2.426 5.197,-7.972 5.197,-7.972 0,-11.091 -11.434,-11.438 -13.859,-11.438 h -12.126 c -0.694,0 -1.04,0.347 -1.04,1.04 v 36.74 c 0,0.347 0.346,1.04 1.04,1.04 h 12.126 c 0,0 13.513,0.346 13.513,-11.438 C 4.504,3.813 2.771,1.386 0,0 m -13.859,3.813 h 5.197 c 0,0 4.851,0 4.851,3.466 0,3.812 -4.851,3.812 -4.851,3.812 h -5.197 z M -3.465,-7.625 c 0,3.812 -5.544,3.466 -5.544,3.466 h -5.197 v -7.279 h 5.197 c 2.427,0 5.544,0.693 5.544,3.813",
    style: {
      fill: "#233833",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(448.6694,109.3427)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v 24.607 c 0,0.347 0.347,1.04 1.04,1.04 h 5.889 c 0.693,0 1.04,-0.347 1.04,-1.04 V 0.347 c 0.346,-3.12 3.118,-5.199 6.237,-5.199 3.118,0 6.236,1.733 6.236,5.199 v 24.607 c 0,0.346 0.346,1.04 1.04,1.04 h 6.235 c 0.694,0 1.04,-0.347 1.04,-1.04 V 0.347 c 0,-8.319 -6.236,-13.171 -14.551,-13.171 C 6.237,-13.171 0,-7.972 0,0",
    style: {
      fill: "#233833",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(518.6569,97.9053)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,-0.347 -0.347,-1.04 -1.04,-1.04 h -5.889 c -0.347,0 -0.693,0 -1.04,0.347 L -23.906,22.181 V -0.347 c 0,-0.346 -0.347,-1.039 -1.04,-1.039 h -5.891 c -0.692,0 -1.038,0.346 -1.038,1.039 v 36.739 c 0,0.346 0.346,1.04 1.038,1.04 h 6.237 c 0.347,0 0.694,0 1.04,-0.347 L -7.622,13.864 v 22.874 c 0,0.347 0.346,1.04 1.04,1.04 h 5.889 c 0.693,0 1.04,-0.346 1.04,-1.04 z",
    style: {
      fill: "#233833",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(534.2814,135.2787)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 9.355,0 22.141,-2.367 22.141,-19.351 0,-16.289 -12.82,-19.062 -22.174,-19.062 h -5.89 c -0.693,0 -1.04,0.347 -1.04,1.04 v 36.392 c 0,0.347 0.347,1.04 1.04,1.04 h 5.89 z m 1.352,-30.789 c 4.505,0 12.82,1.04 12.82,11.438 0,8.665 -4.851,11.438 -11.78,11.438 h -1.04 z",
    style: {
      fill: "#233833",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(571.7581,127.5045)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v -7.492 h 13.617 c 0.68,0 1.021,-0.341 1.021,-1.021 v -5.789 c 0,-0.342 -0.341,-1.023 -1.021,-1.023 H 0 v -7.49 h 16.68 c 0.681,0 1.362,-0.342 1.362,-1.023 v -5.789 c 0,-0.34 -0.341,-1.021 -1.362,-1.021 H -6.808 c -0.681,0 -1.022,0.34 -1.022,1.021 V 6.811 c 0,0.341 0.341,1.022 1.022,1.022 H 16.68 c 0.681,0 1.362,-0.341 1.362,-1.022 V 1.021 C 18.042,0.681 17.701,0 16.68,0 Z",
    style: {
      fill: "#233833",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(607.0076,112.1154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -2.771 v -14.211 c 0,-0.346 -0.347,-1.04 -1.387,-1.04 h -5.89 c -0.692,0 -1.039,0.347 -1.039,1.04 v 36.392 c 0,0.347 0.347,1.04 1.039,1.04 H 2.08 c 2.424,0 13.164,0 13.164,-11.436 0,-5.893 -3.118,-8.666 -6.582,-10.399 1.04,-2.426 2.425,-5.199 3.464,-7.625 l 3.465,-7.279 c 0.347,-0.693 0,-1.386 -1.04,-1.386 H 7.969 c -0.347,0 -1.04,0.347 -1.04,0.693 z M -2.771,7.279 H 2.08 c 1.384,0 4.849,0.346 4.849,3.812 0,3.466 -3.811,3.813 -4.849,3.813 h -4.851 z",
    style: {
      fill: "#233833",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(385.2649,127.0188)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v 0 l -0.693,1.04 c -1.732,1.733 -2.771,3.812 -2.771,6.239 0,3.119 2.771,6.932 8.315,6.932 4.851,0 8.662,-3.12 8.662,-7.279 0,-4.852 -4.851,-7.279 -4.851,-7.625 l 3.811,-3.813 c 0.693,1.04 1.04,2.426 1.386,3.466 C 14.206,0 14.206,0.693 15.591,0 l 3.118,-1.04 c 1.04,-0.346 0.693,-1.386 0.693,-2.079 -1.038,-3.12 -2.771,-5.199 -2.771,-5.546 l 3.811,-3.466 c 0.693,-0.347 1.04,-1.04 0,-2.08 l -2.425,-2.426 c -0.346,-0.347 -1.386,-0.693 -2.079,0 l -2.772,2.773 c 0,0 -2.773,-3.466 -9.355,-3.466 -5.544,0 -9.355,3.812 -9.355,8.318 C -5.891,-2.426 0,0 0,0 m 4.158,-11.438 c 3.464,0 4.504,2.08 4.504,2.08 l -5.544,5.892 c 0,0 -3.118,-1.04 -3.118,-4.506 0,-1.733 2.08,-3.466 4.158,-3.466 m 3.464,18.37 c 0,1.386 -1.386,2.773 -3.118,2.773 -1.733,0 -2.424,-1.04 -2.424,-2.08 0,-1.386 0.691,-2.079 2.078,-3.466 l 1.039,-1.04 c -0.346,0 2.425,1.387 2.425,3.813",
    style: {
      fill: "#0fb2aa",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(382.1465,96.8654)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h 21.067 c 0.346,0 1.04,0.347 1.04,1.04 v 5.892 c 0,0.347 -0.347,1.04 -1.04,1.04 H 0 c -0.347,0 -1.04,-0.347 -1.04,-1.04 V 1.04 C -0.693,0.347 -0.347,0 0,0",
    style: {
      fill: "#fcc243",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(80.8502,103.7759)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C -2.217,-3.318 -7.51,-0.114 -6.029,4.76 -4.54,9.412 4.114,6.451 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(46.1946,126.3001)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 1.142,0.396 2.096,-0.444 2.441,-1.349 0.996,-2.424 0.841,-6.25 1.145,-8.836 0.911,-11.01 9.282,-9.99 15.135,-13.67 0.854,-0.517 0.529,-1.85 -0.527,-2.016 C 11.455,-26.71 -1.688,-22.81 -3.292,-15.553 -4.003,-12.254 -4.295,-1.743 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(57.5031,118.9334)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 2.847,0.365 5.106,-2.929 4.177,-5.302 0.023,-14.352 -9.606,-1.613 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(64.2678,130.6289)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 3.485,-0.431 5.724,-4.814 4.2,-7.215 3.424,-8.458 0.534,-9.161 -0.758,-8.34 -5.299,-5.519 -3.425,0.339 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(58.3198,144.8026)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 8.986,1.64 20.05,-10.911 21.186,-17.544 0.106,-0.996 0.098,-2.82 -1.467,-2.678 -7.281,2.304 -14.488,19.768 -20.806,5.845 -0.75,-2.043 -1.03,-4.495 -2.945,-5.942 -0.867,-0.753 -2.048,-0.004 -2.174,0.94 C -7.568,-14.41 -7.583,-1.29 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(96.042,131.5367)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 1.054,-1.598 0.439,-3.885 -0.862,-5.487 -3.706,-8.484 -9.102,-6.706 -9.444,-2.629 -9.988,5.161 -3.072,4.396 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(106.8988,127.203)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -3.602,2.598 -6.766,5.705 -9.874,8.803 -1.646,1.651 -3.82,3.153 -6.32,3.127 -2.855,-0.178 -4.782,-2.328 -7.24,-3.363 -1.724,-0.768 -4.049,-0.469 -5.431,0.866 -0.909,0.911 -0.544,2.28 0.004,3.231 C -14.376,38.96 13.039,-9.764 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(100.9247,125.018)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 1.193,0.966 3.091,0.925 4.372,0.124 3.69,-2.252 9.568,-8.74 9.801,-12.813 0.114,-3.087 -2.552,-5.438 -5.184,-6.923 -4.116,-2.26 -18.726,-6.838 -19.126,-3.641 -0.135,2.08 3.014,2.606 4.929,3.242 20.36,6.842 8.479,10.395 4.997,15.848 C -0.969,-2.9 -1.067,-1.139 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(96.9027,118.2127)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 1.822,0.613 3.386,-0.598 4.497,-1.937 7.653,-5.632 5.268,-9.515 0.424,-7.886 -2.885,-6.702 -4.01,-1.056 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(85.1702,84.7985)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -0.944,0.807 -1.943,1.574 -2.525,2.66 -0.901,1.481 -0.844,3.268 -0.398,4.87 1.578,5.739 5.035,10.49 7.566,15.864 3.193,7.775 0.433,11.129 -1.426,8.458 -1.135,-2.561 -8.238,-24.92 -13.365,-15.532 -2.142,3.588 -3.243,6.864 -5.398,11.269 -0.655,1.137 -2.388,2.693 -3.695,0.382 -0.987,-2.675 2.92,-8.875 4.043,-11.818 1.302,-3.381 3.489,-6.762 2.767,-10.496 C -12.62,3.575 -14.261,1.902 -14.998,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBbPacht);
export default __webpack_public_path__ + "static/media/logo_bb_pacht.6288b9d97eecdcef425bc85038b44226.svg";
export { ForwardRef as ReactComponent };